    let trustpilotLoaded = false;
    function loadTrustpilotScript() {
      if (!trustpilotLoaded) {
        const script = document.createElement('script');
        script.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
        script.defer = true;
        document.body.appendChild(script);
        trustpilotLoaded = true;
  
        // Remove event listeners after the script is loaded
        window.removeEventListener('mousemove', loadTrustpilotScript);
        window.removeEventListener('touchmove', loadTrustpilotScript);
      }
    }
  
    // Load the Trustpilot script on mousemove or touchmove
    window.addEventListener('mousemove', loadTrustpilotScript);
    window.addEventListener('touchmove', loadTrustpilotScript);
